
    module.exports = function(obj, iterator, context) {
        var results = [];
        if (obj == null) return results;
        if (Array.prototype.filter && obj.filter === Array.prototype.filter) return obj.filter(iterator, context);
        exports.each(obj, function(value, index, list) {
            if (iterator.call(context, value, index, list)) results[results.length] = value;
        });
        return results;
    };




//////////////////
// WEBPACK FOOTER
// ./node_modules/toxiclibsjs/internals/filter.js
// module id = 4576
// module chunks = 14